module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABIBAMAAACnw650AAAAElBMVEXtKTntKTn////97O3vQlDsGSrYhKCwAAAAAXRSTlPxilwa7AAAAD9JREFUSMdjIAoIEgFGFY0qGvaKQokADC5EAAZjIgCDEhFgVNGoolFFQEBUliIqcxKVzQdl+TSqaFQR3RURAwCc8AcImUPIAgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/components/buttonCulture/at.png
// module id = 442
// module chunks = 0